import { render } from "./ContractClientComponent.vue?vue&type=template&id=58cbb460&scoped=true"
import script from "./ContractClientComponent.vue?vue&type=script&lang=js"
export * from "./ContractClientComponent.vue?vue&type=script&lang=js"

import "./ContractClientComponent.vue?vue&type=style&index=0&id=58cbb460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cbb460"]])

export default __exports__